const ROUTES = {
  ROOT: "/",
  MAP: "/map",
  POKEMON_CARDS: "/pokemontcg",
  WISHLIST: "/wishlist",
  COLLECTION: "/collection",
  TRADES: "/trades",
  TRADE_DETAIL: "/trades/:tradeId",
  CHAT: "/chat",
  SIGNUP: "/signup",
  LOGIN: "/login",
  EDIT_USER: "/edit_user_page",
  PROFILE: "/profile",
  ADMIN: "/admin",
  ADMIN_EMAILS: "/admin/emails",
  ADMIN_TRADES: "/admin/trades",
  ADMIN_MODERATION: "/admin/moderation",
  ADMIN_REPORTS: "/admin/reports",
  ADMIN_ERRORS: "/admin/errors",
  ADMIN_FEEDBACK: "/admin/feedback",
  ADMIN_DELETION_REQUESTS: "/admin/deletion-requests",
  ADMIN_SAFE_SPOTS: "/admin/safe-spots",
  ADMIN_CHALLENGE_REVIEW: "/admin/challenge-evidence",
  ADMIN_SETTINGS: "/admin/settings",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password/:token",
  VERIFY_EMAIL: "/verify-email/:token",
  // Tokenless entry to the same page. The resend form used to live ONLY on
  // the :token route — reachable exclusively from the email a blocked user had
  // not received. This is the door for someone who never got one.
  VERIFY_EMAIL_HELP: "/verify-email",
  AUTH_CALLBACK: "/auth/callback",
  OAUTH_CONSENT: "/oauth/consent",
  DELETE_ACCOUNT_REQUEST: "/delete-account",
  PRIVACY: "/privacy",
  TERMS: "/terms",
  // The public trade list (docs/PUBLIC_TRADE_LIST.md). The shared link is
  // /t/<slug>, which the live site rewrites to the server's page; /trade-list
  // is where that page's "Offer a trade" buttons land, and no rewrite takes it.
  TRADE_LIST_SHARED: "/t/:slug",
  TRADE_LIST_OFFER: "/trade-list/:slug",
};
export default ROUTES;
